import { render, staticRenderFns } from "./PopupTanimla.vue?vue&type=template&id=f5144756&scoped=true&"
import script from "./PopupTanimla.vue?vue&type=script&lang=js&"
export * from "./PopupTanimla.vue?vue&type=script&lang=js&"
import style0 from "./PopupTanimla.vue?vue&type=style&index=0&id=f5144756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5144756",
  null
  
)

export default component.exports